module.exports = __webpack_public_path__ + "img/Pos.eb373bb3.svg";